import { defineCustomElement } from 'vue'
import NavHeaderCE from './NavHeader.ce.vue'

const NavHeaderElement = defineCustomElement(NavHeaderCE)

if (typeof customElements !== 'undefined' && !customElements.get('comake-header')) {
  customElements.define('comake-header', NavHeaderElement)
}

export { NavHeaderElement }
export type { NavConfig, NavItem, NavUser, NavLangOption } from './types/nav'
